<template>
  <div>
    {{formatDate(current_date)}}
    <span v-if="today === date">
       <br/>
      <span class="badge rounded-pill font-size-11 badge-soft-secondary mr-1">Today</span>
    </span>
  </div>
</template>

<script>
import moment from "moment"
export default {
name: "date-is-today",
  props:{
    current_date:{type: String}
  },
  computed: {
    today: function () {
      return new Date().toDateString()
    },
    date: function () {
      return new Date(this.current_date).toDateString()
    }
  },
  methods: {
  formatDate(oldDate){
    if (oldDate != null){
      return moment(oldDate).format('LL')
    }

  }
  }
}
</script>

<style scoped>

</style>
